module.exports = __webpack_public_path__ + "static/media/player_close.fd2c862f.png";